import { ButtonProps } from '~components/Button';

import * as S from './style';

export default function ButtonMore(props: Omit<ButtonProps, 'children'>) {
  return (
    <S.Wrapper variant='light' size='sm' {...props}>
      자세히 보기
    </S.Wrapper>
  );
}
